import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GenericError, PagedList, pagedListUtilities, dateUtilities, SearchComponent, SiteProgramSearchComponent } from '../../common';
import { tenantHelpers } from '../../tenantInfo';
import * as registeredParticipantsActions from './registered-participants.actions';
import './registered.scss';
import * as sitesActions from '../../permissions/touchpoint/site-list-folder/site-list.actions';
import { toastr } from 'react-redux-toastr';
import { RadioElement } from '../../common/form-elements';
import { List } from 'immutable';
const emptyGuid = '00000000-0000-0000-0000-000000000000';

export class RegisteredParticipantsComponent extends Component {

  componentDidMount() {
    const { registeredParticipantsActions, sitesActions } = this.props;
    registeredParticipantsActions.fetchList();
    const { fetchSiteProgramEnabledList } = sitesActions || {};

    fetchSiteProgramEnabledList();
  }

  componentWillUpdate(nextProps, nextState) {
    const { registeredParticipantsActions } = this.props;
    registeredParticipantsActions.fetchList();
  }

   /**
   * Function that executes when the user selects the site on the add intake modal
   * @param {Guid} selectedSite : the Guid of the site of which to create the intake form
   */
  handleUpdateSite(selectedSiteId) {
    const { sitesActions, sites } = this.props;
    const { changeSelectedSite } = sitesActions || {};
    const { fetchProgramsForSite } = sitesActions || {};
    const { siteListState } = sites || {};
    const siteData = siteListState && siteListState.data && siteListState.data.results;
    const siteIndex = siteData && siteData.findIndex(res => res.id === selectedSiteId);
    const selectedSite = siteData && siteData[siteIndex];
    changeSelectedSite(selectedSiteId);
    if (!!selectedSite) fetchProgramsForSite(selectedSiteId);
  }

  /**
   * Function that executes when the user selects the program on the add intake modal
   * @param {Guid} selectedProgramId : the Guid of the program of which to create the intake form
   */
  handleUpdateProgram(selectedProgramId) {
    const { sitesActions } = this.props;
    const { changeSelectedProgram } = sitesActions || {};

    changeSelectedProgram(selectedProgramId);
  }

  /**
   * Function that calls the action class to update the store with the radiobutton element
   * @param {string} value : value of the radiobutton element
   */
  handleSelectionChange(value) {
    const { registeredParticipantsActions, sitesActions } = this.props;
    const option = !!value && value.size > 0 ? value.get(0) : undefined;
    const radioButtonOption = (option === 'true');
    if(!radioButtonOption) {
      sitesActions.clearSiteProgramIds();
    }
    registeredParticipantsActions.setSelectedSaveOption(option);
  }

  renderParticipant(participant) {
    const guidEmpty = '00000000-0000-0000-0000-000000000000';
    const { registeredParticipants, registeredParticipantsActions } = this.props;
    const { selectParticipant } = registeredParticipantsActions;
    const { enabledParticipants, disabledParticipants } = registeredParticipants;

    const { participantId, participantEmail, lastLogin, status, demographics } = participant || {};
    const { firstName, lastName, dob, externalId } = demographics || {};

    const participantSelected = status === 'Enabled' ? enabledParticipants.some(id => id === participant.participantId) :
      disabledParticipants.some(id => id === participant.participantId);

    return (
      <tr key={participantId === guidEmpty ? externalId : participantId}>
        <td><input type="checkbox" checked={participantSelected} onChange={e => selectParticipant(participantId, status)}/></td>
        <td>{firstName}</td>
        <td>{lastName}</td>
        <td>{participantEmail}</td>
        <td>{dateUtilities.getUserFriendlyFormatFromJson(dob)}</td>
        <td>{dateUtilities.getUserFriendlyFormatFromJson(lastLogin)}</td>
        <td>{status}</td>
      </tr>);
  }

  handleEnable() {
    const { registeredParticipants, registeredParticipantsActions } = this.props;
    const { disabledParticipants } = registeredParticipants;

    if(disabledParticipants.size === 0) {
      toastr.error("", "Select at least one disabled account to enable.");
      return;
    }

    registeredParticipantsActions.enableParticipants()
      .then(val => {
        var successes = val.successResults.length;
        var failures = val.errorResults.length;
        var successText = successes + " enabled. " + (successes > 1 ? "Each" : "The")
          + " participant will receive an email with a link to reset his or her password and log in again.";
        var failureText = "Unable to enable " + failures + " account" + (failures > 1 ? "s" : "");
        if(successes > 0) {
          toastr.success("Success", successText + (failures > 0 ? " " + failureText : ""));
        }
        else {
          toastr.error("Failure", failureText);
        }
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  handleDisable() {
    const { registeredParticipants, registeredParticipantsActions } = this.props;
    const { enabledParticipants } = registeredParticipants;

    if(enabledParticipants.size === 0) {
      toastr.error("", "Select at least one active account to disable.");
      return;
    }

    registeredParticipantsActions.disableParticipants()
      .then(val => {
        var successes = val.successResults.length;
        var failures = val.errorResults.length;
        var successText = successes + " disabled. " + (successes > 1 ? "Each" : "The")
          + ` participant will no longer be able to log in to ${tenantHelpers.getProductName()}.`;
        var failureText = "Unable to disable " + failures + " account" + (failures > 1 ? "s" : "");
        if(successes > 0) {
          toastr.success("Success", successText + (failures > 0 ? " " + failureText : ""));
        }
        else {
          toastr.error("Failure", failureText);
        }
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  render() {
    const { registeredParticipants, registeredParticipantsActions, sites, programState } = this.props;
    const { changeSort, changePageNumber, changeResultsPerPage, selectAllParticipants, setSearchText, startSearch } = registeredParticipantsActions;
    const { pagingData, listState, enabledParticipants, disabledParticipants, searchInput, searchQuery } = registeredParticipants;
    const { itemsPerPage, sortBy, sortAsc } = pagingData || {};
    const { isFetching, err, data } = listState || {};

    const { isFetching: isFetchingSites } = sites || {};

    const siteData = sites && sites.siteListState && sites.siteListState.data && sites.siteListState.data.results;

    const { isFetching: isFetchingPrograms } = programState || {};
    const isSiteSelected = sites && sites.selectedSiteId && sites.selectedSiteId !== emptyGuid;

    const progData = sites && sites.programLists && sites.programLists.get(sites.selectedSiteId);
    const programData = progData && progData.data;

    const currentSelectedSite = sites.selectedSiteId;
    const currentSelectedProgram = sites.selectedProgramId;

    const siteList = [{ value : null, label : '--Select--'}];
    !!siteData && siteData.forEach(site => {  siteList.push({ value: site.id, label: site.name })});
    const programList = [{ value : null, label : '--Select--'}];
    !!programData && programData.forEach(program => {  programList.push({ value: program.id, label: program.name })});
    const isSiteDisabled = isFetchingSites || isFetchingPrograms;
    const isProgramDisabled = !isSiteSelected || isFetchingSites || isFetchingPrograms;

    var participantList = [];
    var currentPage = 1;
    var totalItemsCount = 0;
    if(data) {
      participantList = data.results;
      currentPage = data.currentPage;
      totalItemsCount = data.totalResults;
    }

    if (err) {
      return <GenericError err={err} />
    }

    var selectedParticipantsCount = (enabledParticipants ? enabledParticipants.size : 0) + (disabledParticipants ? disabledParticipants.size : 0);

    const allParticipantsSelected = participantList.every(val =>
      enabledParticipants.some(id => id === val.participantId) ||
      disabledParticipants.some(id => id === val.participantId));

      const headerNames = new Map([
        ['fname', {
          displayName: 'FIRST NAME',
          dataType: 'alpha' }],
        ['lname', {
          displayName: 'LAST NAME',
          dataType: 'alpha' }],
        ['email', {
          displayName: 'EMAIL',
          dataType: 'alpha' }],
        ['dob', {
          displayName: 'DATE OF BIRTH',
          dataType: 'date' }],
        ['login', {
          displayName: 'LAST LOGIN',
          dataType: 'date' }],
        ['status', {
          displayName: 'STATUS',
          dataType: 'alpha' }]]);

    const sortText =  pagedListUtilities.getSortText(headerNames, sortBy, sortAsc);
    const sortMessage = " Participants sorted by " + sortText;
    const contentLoadedMessage = "Content Loaded. " + sortMessage;

    const headerColumns = pagedListUtilities.buildSortHeader(headerNames, sortBy, sortAsc, changeSort);
    const headers = (
      <tr>
        <th><input type="checkbox" checked={allParticipantsSelected} onChange={e => selectAllParticipants()}/></th>
        {headerColumns}
      </tr>
    );

    const perPageOptions = [
      { value : 5, label : '5' },
      { value : 10, label : '10'},
      { value : 25, label : '25'},
      { value : 50, label : '50'}
    ];

    const saveOptions = List([
      { id: 0, value: 'true', label: "Search by Site / Program" },
      { id: 1, value: 'false', label: "Search by last name / email" }
    ]);

    return (
      <div id='registered-participants'>
        <div className='radio-button'>
            <RadioElement
              isRequired={false}
              label=""
              options={saveOptions}
              disabled={false}
              defaultValue={List([registeredParticipants.radioButtonValue])}
              onChange={(value) => this.handleSelectionChange(value)}
              css={{ buttonWrapper: 'col-md-5', buttonLabel: 'save-list', radioButton: 'save-list', label: 'save-list'}}  />
        </div>

        <div className='search-component'>
          {registeredParticipants.radioButtonValue === 'false' ?
            <SearchComponent
              instructionText={'Enter part or all of the user’s last name or email address and click Search to filter.'}
              searchInput={searchInput}
              searchQuery={searchQuery}
              setSearchText={text => setSearchText(text)}
              startSearch={() => startSearch()}
              /> :
            <SiteProgramSearchComponent
              siteList={siteList}
              currentSelectedSite={currentSelectedSite}
              isSiteDisabled={isSiteDisabled}
              isFetchingSites={isFetchingSites}
              programList={programList}
              currentSelectedProgram={currentSelectedProgram}
              isProgramDisabled={isProgramDisabled}
              isFetchingPrograms={isFetchingPrograms}
              handleUpdateSite={selectedSite => this.handleUpdateSite(selectedSite)}
              handleUpdateProgram={selectedProgram => this.handleUpdateProgram(selectedProgram)}
              startSearch={() => startSearch()}
            />
          }
        </div>
        {/* TODO: removing this until the CSV export feature is available
        <button className='btn btn-default right-align' aria-label='CSV Export'>
          <span className='glyphicon glyphicon-export'/>
        </button>
        */}
        <PagedList
          header={headers}
          items={participantList}
          emptyMessage={<p>No Registered Participants Found</p>}
          mapItem={participant => this.renderParticipant(participant)}
          currentPage={currentPage}
          resultsPerPage={itemsPerPage}
          variableResultsPerPage={true}
          perPageOptions={perPageOptions}
          totalItemsCount={totalItemsCount}
          changePageNumber={page => changePageNumber(page)}
          changeResultsPerPage={numResults => changeResultsPerPage(numResults)}
          isLoading={isFetching}
          loadingMessage='Loading Registered Participants...'
          contentLoadedMessage={contentLoadedMessage} />
        <div className='center-align'>
          <button
            className='btn btn-primary centered-button'
            onClick={e => this.handleEnable()}
            disabled={selectedParticipantsCount === 0}>
            Enable {disabledParticipants && disabledParticipants.size > 0 ? <span>({disabledParticipants.size})</span> : null}
          </button>
          <button
            className='btn btn-primary centered-button'
            onClick={e => this.handleDisable()}
            disabled={selectedParticipantsCount === 0}>
            Disable {enabledParticipants && enabledParticipants.size > 0 ? <span>({enabledParticipants.size})</span> : null}
          </button>
        </div>
      </div>
    );
  }
}

RegisteredParticipantsComponent.propTypes = {
  currentSelectedSite: PropTypes.string,
  currentSelectedProgram: PropTypes.string
};

const mapStateToProps = ({ registeredParticipants, sites }) => {
  return {
    registeredParticipants,
    sites
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    registeredParticipantsActions: bindActionCreators(registeredParticipantsActions, dispatch),
    sitesActions: bindActionCreators(sitesActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisteredParticipantsComponent);
